module.exports = __webpack_public_path__ + "static/media/toezicht.0ac3e96c.svg";